// frontend/src/utils/useCurrency.js
// Detects visitor region via browser timezone and returns the appropriate currency symbol.
// EUR (€) for Europe (default), USD ($) for Americas, GBP (£) for UK.

import { useMemo } from 'react';

function detectCurrencySymbol() {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';

        // UK → Pound
        if (tz === 'Europe/London' || tz === 'Europe/Belfast') {
            return '£';
        }

        // Americas (North, Central, South) → Dollar
        if (tz.startsWith('America/') || tz.startsWith('US/') || tz.startsWith('Canada/') || tz.startsWith('Brazil/')) {
            return '$';
        }

        // Pacific islands sometimes in USD zones
        if (tz.startsWith('Pacific/') && ['Pacific/Guam', 'Pacific/Wake', 'Pacific/Midway'].includes(tz)) {
            return '$';
        }

        // Default: Euro (Spain, EU, and everywhere else)
        return '€';
    } catch {
        return '€';
    }
}

export function useCurrency() {
    const symbol = useMemo(() => detectCurrencySymbol(), []);
    return symbol;
}
